module.exports = __webpack_public_path__ + "static/media/Remember Modify Tools Setting across Revit Sessions.fcd44690.png";